import { Appointment, TagRecord } from "@elixir/types";
import { getIdb, updateAppointment } from "../../utils/bridges/methods";
import { logAndGetErrorResponse } from "../error";
import { ControllerReturnType } from "../types";
import getB from "../../utils/bridges/EkaBridge";
import {
  trackAppointmentActivity,
  AptActivityType,
} from "./appointment-activity";

export default async function tagAppointment({
  appointment,
  tagId,
  updatedTags
}: {
  appointment: Pick<Appointment, "aid" | "tags">;
  tagId: TagRecord["tag_id"];
  updatedTags: (number | string)[]
}): Promise<ControllerReturnType> {
  try {
    const { aid } = appointment;
    const apt = await getIdb().appointments.get(aid);
    let tags = apt?.tags || appointment.tags || [];

    let activity: AptActivityType = AptActivityType.APT_TAG_ADDED;

    if (tags.includes(tagId)) {
      activity = AptActivityType.APT_TAG_DELETED;
      tags = tags.filter((tagId) => tagId !== tagId);
    } else {
      activity = AptActivityType.APT_TAG_ADDED;
      tags.push(tagId);
    }

    await updateAppointment({
      data: {
        tags: updatedTags,
      },
      aid,
    });

    trackAppointmentActivity({ aid, activity });
    return { success: true };
  } catch (e) {
    return logAndGetErrorResponse(e);
  }
}
